import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Container, Col, Button } from "react-bootstrap";
import "./CodeOverview.scss";
//import JSZip from "jszip";
import ReactMarkdown from "react-markdown";
import Scrollbars from "react-custom-scrollbars-2";
import { updateOverview } from "../../state/reducers/codeOverview";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClipboard, faDownload, faCheck, faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import CustomButton from "../../common-components/button/Button.jsx";


const Overview = () => {
  const overviewData = useSelector((state) => state.codeOverview.overview)
  const dispatch = useDispatch();
  const [copied, setCopied] = useState(false);

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      
      // Reset the icon after 2 seconds
      setTimeout(() => {
        setCopied(false);
      }, 2000);
    }, (err) => {
      console.error("Could not copy text: ", err);
    });
  };

  const downloadResult = () => {
    const element = document.createElement("a");
    const file = new Blob([overviewData], {type: "text/plain"});
    element.href = URL.createObjectURL(file);
    element.download = "overviewData.txt";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  return (
    <div className="page-wrapper code-overview-page px-3">
      <Container fluid>
        <Row>
          <Col>
            <div className="content-wrap">
              <h2 className="page-title">Code Overview</h2>
              <div className="code-overview-wrapper">
                {overviewData && (
                  <>
                    <Row>
                      <Col>
                        <div className="overview-text-wrapper">
                          <button className="copy-btn" onClick={() => copyToClipboard(overviewData)}>
                            <FontAwesomeIcon icon={copied ? faCheck : faClipboard} className="copy-icon"/> <span>Copy</span>
                          </button>
                          <Scrollbars>
                            <ReactMarkdown className="overview-text">
                              {overviewData}
                            </ReactMarkdown>
                          </Scrollbars>
                        </div>
                        <div className="text-end">
                          <CustomButton label={<><FontAwesomeIcon icon={faAngleLeft} className="dld-icon" /> <span>Back</span></>} onClick={() => dispatch(updateOverview(false))} className="back-btn" />
                          <button className="download-btn me-0" onClick={downloadResult}>
                            <FontAwesomeIcon icon={faDownload} className="dld-icon" /> <span>Download Code Overview</span>
                          </button>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="text-end  d-none">
                        <Button 
                          className="blue-btn"
                          onClick={() => {
                            dispatch(updateOverview(false))
                          }}
                        >
                          Back
                        </Button>
                      </Col>
                    </Row>
                  </>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Overview;